import { z } from "zod";

export const gradingSchema = z.object({
  passingGrade: z.enum(["5.0", "5.5", "6.0"]),
  maxScore: z
    .string()
    .refine(
      (v) => {
        const n = Number(v);
        return !isNaN(n) && v?.length > 0;
      },
      { message: "Waarde is geen nummer" },
    )
    .refine((v) => Number(v) > 0, { message: "Waarde moet groter zijn dan 0" })
    .refine((v) => Number(v) <= 300, {
      message: "Waarde moet kleiner of gelijk zijn aan 300",
    }),
  term: z
    .string()
    .refine(
      (v) => {
        const n = Number(v);
        return !isNaN(n) && v?.length > 0;
      },
      { message: "Waarde is geen nummer" },
    )
    .refine((v) => Number(v) > 0, { message: "Waarde moet groter zijn dan 0" })
    .refine((v) => Number(v) <= 200, {
      message: "Waarde moet kleiner of gelijk zijn aan 200",
    }),
  linearPercentage: z
    .string()
    .refine(
      (v) => {
        const n = Number(v);
        return !isNaN(n) && v?.length > 0;
      },
      { message: "Waarde is geen nummer" },
    )
    .refine((v) => Number(v) > 0, { message: "Waarde moet groter zijn dan 0" })
    .refine((v) => Number(v) <= 100, {
      message: "Waarde moet kleiner of gelijk zijn aan 100",
    }),
  pointsType: z.enum(["full", "half", "quarter", "tenth"]),
});

export type GradingFormSchema = z.infer<typeof gradingSchema>;

export type PointsType = GradingFormSchema["pointsType"];
